import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class TimeCountUp extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, totalTimeInMilliseconds, txtSize, txtFont, txtColor) {
    super(scene);

    this.allCharacters = [];
    this.allNums = [];
    const formattedTimeStr = this.formatTimeString(totalTimeInMilliseconds);

    this.countSound = ABCyaPhaser.Audio.createSound(this.scene);

    const nums = '0123456789';
    let i = 0;
    while (i < formattedTimeStr.length) {
      const char = formattedTimeStr.charAt(i);
      const charText = ABCyaPhaser.Text.addText(0, 0,`${txtSize}pt`, txtColor, txtFont, char, this, false).setOrigin(0, 0.5);

      const charObject = { txt: charText,targetChar: char };
      this.allCharacters.push(charObject);
      if (nums.indexOf(char) !== -1) this.allNums.push(charObject);
      i++;
    }

    // cut up into individual characters and align
    this.initNumCount();
    this.positionAllCharacters();
  }

  initNumCount() {
    for (let i = 0; i < this.allNums.length; i++) {
      this.allNums[i].txt.text = '0';
    }
  };

  positionAllCharacters() {
    let i = 0;
    while (i < this.allCharacters.length) {
      const char = this.allCharacters[i].txt;
      char.x = i === 0 ? 0 : this.allCharacters[i - 1].txt.x + this.allCharacters[i - 1].txt.getBounds().width;
      i++;
    }
  };

  showFullCount() {
    for (let i = 0; i < this.allNums.length; i++) {
      this.allNums[i].txt.text = this.allNums[i].targetChar;
    }
  };

  formatTimeString(timeInMilliseconds) {
    const seconds = timeInMilliseconds / 1000;
    const wholeSeconds = Math.floor(seconds);

    const secondsStr = wholeSeconds.toString();

    let milliStr = (timeInMilliseconds - (wholeSeconds * 1000)).toString();
    if (milliStr.length < 2) milliStr = `0${milliStr}`;
    if (milliStr.length > 2) milliStr = milliStr.substring(0,2);

    return `${secondsStr}.${milliStr}`;
  };
}